import router from "../../router/index";
import { userService } from "../../helpers/authservice/user.service";
import { isTokenExpired } from "@/helpers/authservice/tokenUtils.js";

// 1. State
export const state = {
  status: "authenticating", //'authenticated','not-authenticated','authenticating'
  user: null,
  idToken: null,
  refreshToken: null,
  loading: false, // Estado de carga
};

// 2. Mutations
export const mutations = {
  loginStart(state) {
    state.loading = true;
  },
  loginSuccess(state, { data, user }) {
    state.idToken = data.access_token;
    state.refreshToken = data.refresh_token;
    state.user = user;
    state.status = "authenticated";
    state.loading = false;
  },
  loginError(state) {
    state.loading = false;
  },
  logout(state) {
    state.user = null;
    state.idToken = null;
    state.refreshToken = null;
    state.status = "not-authenticated";
    state.loading = false;
    sessionStorage.clear();
  },
  refreshTokenStart(state) {
    state.loading = true;
  },
  refreshTokenSuccess(state, newToken) {
    state.idToken = newToken;
    state.status = "authenticated";
  },
};

// 3. Getters
export const getters = {
  getAuthData(state) {
    return state;
  },
  getCurrentState(state) {
    return state.status;
  },
};

// 4. Actions
export const actions = {
  async loginAction({ dispatch, commit }, payload) {
    commit("loginStart");

    const { success, data, user = null } = await userService.login(payload);

    if (success) {
      commit("loginSuccess", { data, user });

    //   await dispatch("crmSetting/fetchCrmSettings", null, { root: true });

    //   const isNewUser = this.getters["crmSetting/getIsNewUser"];
    //   if (isNewUser) {
        // router.push({ name: "activacion" });
    //   } else {
        // Cargar permisos y módulos
        // await dispatch('permisos/fetchPermissions', { username: user.userName }, { root: true })
    //   }
        router.push("/");
    } else {
      commit("loginError");
      dispatch("notification/error", data, { root: true });
    }
  },

  async callRefreshToken({ commit }, refreshToken) {

    commit("refreshTokenStart");
  
    try {
      const payload = {
        refresh_token: refreshToken,
      };
  
      console.log(payload);
      const response = await userService.refreshToken(payload);
  
      if (response.data) {
        commit("refreshTokenSuccess", response.data.access_token);
        sessionStorage.setItem("idToken", response.data.access_token);
        return response.data.access_token;
      } else {
        commit("logout");
        sessionStorage.clear();
        router.push("/login");
        return Promise.reject('error al recuperar la sesión');
      }
    } catch (error) {
      commit("logout");
      sessionStorage.clear();
      router.push("/login");
      return Promise.reject(error);
    }
  
  },
  async checkAuthentication({ commit }) {
    //para el caso de que el user recargue la página
    const idToken = sessionStorage.getItem("idToken");
    const refreshToken = sessionStorage.getItem("refreshToken");
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!idToken) {
      commit("logout");
      return false;
    }

    //esto se usará en caso de que el usuario recargue la pagina o se salga del navegador
    if (!isTokenExpired(idToken)) {
      //token valido
      const data = { access_token: idToken, refresh_token: refreshToken };
      commit("loginSuccess", { data, user });
      return true;
    } else {
      commit("logout");
      return false;
    }
  },

  logoutAction({ commit }) {
    commit("logout");
    // dispatch('permisos/resetPermissions', null, { root: true });
    // dispatch("crmSetting/resetCrmSettingsAction", null, { root: true });
    // commit('storeCoreDescargaSat/hideNotifications', null, { root: true });

    // Limpiar storage
    sessionStorage.clear();

    router.push("/login");
  },
};

// import { getFirebaseBackend } from '../../authUtils.js'

// export const state = {
//     currentUser: sessionStorage.getItem('authUser'),
// }

// export const mutations = {
//     SET_CURRENT_USER(state, newValue) {
//         state.currentUser = newValue
//         saveState('auth.currentUser', newValue)
//     }
// }

// export const getters = {
//     // Whether the user is currently logged in.
//     loggedIn(state) {
//         return !!state.currentUser
//     }
// }

// export const actions = {
//     // This is automatically run in `src/state/store.js` when the app
//     // starts, along with any other actions named `init` in other modules.
//     // eslint-disable-next-line no-unused-vars
//     init({ state, dispatch }) {
//         dispatch('validate')
//     },

//     // Logs in the current user.
//     logIn({ commit, dispatch, getters }, { email, password } = {}) {
//         if (getters.loggedIn) return dispatch('validate')

//         return getFirebaseBackend().loginUser(email, password).then((response) => {
//             const user = response
//             commit('SET_CURRENT_USER', user)
//             return user
//         });
//     },

//     // Logs out the current user.
//     logOut({ commit }) {
//         // eslint-disable-next-line no-unused-vars
//         commit('SET_CURRENT_USER', null)
//         return new Promise((resolve, reject) => {
//             // eslint-disable-next-line no-unused-vars
//             getFirebaseBackend().logout().then((response) => {
//                 resolve(true);
//             }).catch((error) => {
//                 reject(this._handleError(error));
//             })
//         });
//     },

//     // register the user
//     register({ commit, dispatch, getters }, { username, email, password } = {}) {
//         if (getters.loggedIn) return dispatch('validate')

//         return getFirebaseBackend().registerUser(username, email, password).then((response) => {
//             const user = response
//             commit('SET_CURRENT_USER', user)
//             return user
//         });
//     },

//     // register the user
//     // eslint-disable-next-line no-unused-vars
//     resetPassword({ commit, dispatch, getters }, { email } = {}) {
//         if (getters.loggedIn) return dispatch('validate')

//         return getFirebaseBackend().forgetPassword(email).then((response) => {
//             const message = response.data
//             return message
//         });
//     },

//     // Validates the current user's token and refreshes it
//     // with new data from the API.
//     // eslint-disable-next-line no-unused-vars
//     validate({ commit, state }) {
//         if (!state.currentUser) return Promise.resolve(null)
//         const user = getFirebaseBackend().getAuthenticatedUser();
//         commit('SET_CURRENT_USER', user)
//         return user;
//     },
// }

// // ===
// // Private helpers
// // ===

// function saveState(key, state) {
//     window.sessionStorage.setItem(key, JSON.stringify(state))
// }